import type { SubEntryType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  ModalBody,
  ModalCloseX,
  ModalHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"


import { DateTimeInput } from "./DateTimeInput"
import { SubEntryTypeSelector } from "./SubEntryTypeSelector"
import { usePolyglot } from "src/contexts"
import styles from "src/styles/entryModal.module.scss"
import type {
  EditableSubEntry,
  EditableUserEntry,
} from "src/types"

interface Props {
  createSubEntry: (subentry: EditableSubEntry<SubEntryType>) => void;
  currentSubEntry: EditableSubEntry<undefined>;
  currentUserEntry: EditableUserEntry;
}

const polyglotPrefix = "components.entry_modal."

// TODO should this also use the same order as the feed buttons ?
const availableTypes: Array<SubEntryType> = [
  ActivityType.Food,
  ActivityType.Exercise,
  ActivityType.Insulin,
  ActivityType.Medication,
  ActivityType.Glucose,
  ActivityType.DeviceChange,
  ActivityType.Liquid,
  ActivityType.Note,
]

export function SubEntryTypeSelectors(props: Props) {
  const {
    createSubEntry,
    currentUserEntry,
    currentSubEntry,
  } = props

  const polyglot = usePolyglot()

  const onClickSubEntryType = useCallback(
    (subEntryType: SubEntryType) => {
      createSubEntry({
        ...currentSubEntry,
        subentry_type: subEntryType,
      })
    },
    [
      currentSubEntry,
      createSubEntry,
    ],
  )

  const title = currentUserEntry.subentries.length ?
    polyglot.t(`${polyglotPrefix}add_another_item_title`) :
    polyglot.t(`${polyglotPrefix}add_item_title`)

  return (
    <>
      <ModalHeading>
        <div id="add-another-item">
          {title}
          <DateTimeInput
            currentUserEntry={currentUserEntry}
            readonly
          />
        </div>
        <ModalCloseX id={"close-modal"}/>
      </ModalHeading>
      <ModalBody className={styles.modalBody}>
        {
          availableTypes.map(
            (subEntryType) => (
              <SubEntryTypeSelector
                key={subEntryType}
                subEntryType={subEntryType}
                onClick={onClickSubEntryType}
              />
            ),
          )
        }
      </ModalBody>
    </>
  )
}
